import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { PDP_SELECTION_VALIDITY_STATES, PDP_DECIDELATER_TAB_ID, PDP_CUSTOMIZE_TAB_ID, PDP_READYTOSHIP_TAB_ID } from 'commons/constants';
import useCart from 'data-hooks/useCart';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import useProductFavoriteV2 from 'data-hooks/useProductFavoriteV2';
import useUserCartEvent from 'data-hooks/useEvents/useUserCartEvent';
import useModularDetails from 'data-hooks/useModularDetails';
import useModularPDPCart from 'data-hooks/useModularPDPCart';
import { getCombinedOptionSKUs } from 'data-hooks/useProductLocalStock/utils';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPPrice from 'data-hooks/usePDPPrice';
import useJbEventFBAddToCart from 'hooks/sendFBEventHooks/useJbEventFBAddToCart';
import lastInsightsClickAtom from 'components/consumer/consumer-search/advanced-search/atoms/lastInsightsClickAtom';
import { useAtom } from 'jotai';
import handleInsightsAddToCart from 'components/consumer/consumer-search/algolia-insights-helpers/handleInsightsAddtoCart';
import PDPAddToBagSectionUI from './PDPAddToBagSectionUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
import usePdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/usePdpSelectedProtectionPlanId';
import usePDPOptions from '../state/context/usePDPOptions';
import usePDPStockAvailability from '../state/context/usePDPStockAvailability';
import PDPAddToBagSectionPlaceholder from './PDPAddToBagSectionPlaceholder';
const PDPAddToBagSectionInner = t0 => {
  const $ = _c(50);
  const {
    mode: t1,
    onAddToCartClicked,
    pageLoading,
    productId: t2,
    slug: t3,
    stickyDesktopButtonOnly: t4,
    isEditOrder: t5
  } = t0;
  const mode = t1 === undefined ? "pdp" : t1;
  const productId = t2 === undefined ? null : t2;
  const slug = t3 === undefined ? null : t3;
  const stickyDesktopButtonOnly = t4 === undefined ? false : t4;
  const isEditOrder = t5 === undefined ? false : t5;
  const [addToCartError, setAddToCartError] = useState(null);
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {};
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  const [buildYourOwnDetails, updateBuildYourOwnDetails] = useState(t6);
  const [lastInsightsClick] = useAtom(lastInsightsClickAtom);
  const {
    isFavorited
  } = useProductFavoriteV2();
  const {
    data: priceData
  } = usePDPPrice();
  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();
  const {
    loading: basicDetailsLoading,
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    loading: modularDetailsLoading,
    data: modularDetailsData
  } = useModularDetails(slug);
  const {
    data: t7,
    actions: t8
  } = useModularPDPCart(productId, slug);
  const {
    addingToCart: modularAddingToCart,
    modularTotalPrice
  } = t7;
  const {
    addModularToCart
  } = t8;
  const {
    loading: optionsLoading,
    data: optionData
  } = usePDPOptions();
  const {
    loading: availabilityLoading,
    data: t9
  } = usePDPStockAvailability();
  const {
    isEFGInternal,
    isMarkedOOSOrDiscontinued,
    isOutOfStock,
    isDiscontinued
  } = t9;
  const {
    data: t10,
    actions: t11
  } = useCart();
  const {
    addingToCart
  } = t10;
  const {
    addToCart
  } = t11;
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const {
    data: t12
  } = usePDPFabricFilters(slug, isEditOrder);
  const {
    selectedMaterial
  } = t12;
  let t13;
  if ($[1] !== priceData) {
    t13 = priceData || {};
    $[1] = priceData;
    $[2] = t13;
  } else {
    t13 = $[2];
  }
  const {
    isClearance,
    clearanceStockPerSKU
  } = t13;
  const isDecideLaterTab = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const isRTSTab = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID;
  const {
    addToCartEvent
  } = useUserCartEvent(basicDetails, optionData, priceData, isClearance, isFavorited);
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const pdpSelectedProtectionPlanId = usePdpSelectedProtectionPlanId();
  let t14;
  if ($[3] !== addModularToCart || $[4] !== addToCart || $[5] !== addToCartEvent || $[6] !== basicDetails || $[7] !== lastInsightsClick || $[8] !== mode || $[9] !== onAddToCartClicked || $[10] !== optionData.selectedOptions || $[11] !== pdpIsModularBYOProduct || $[12] !== pdpSelectedCustomizerTab || $[13] !== pdpSelectedProtectionPlanId) {
    t14 = async () => {
      if (pdpIsModularBYOProduct) {
        addModularToCart({
          decideLater: pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID
        });
        return;
      }
      setAddToCartError(null);
      const {
        errors,
        cart,
        cartToken
      } = await addToCart({
        productId: basicDetails.id,
        selectedOptions: optionData.selectedOptions,
        decideLater: pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID,
        selectedProtectionPlanId: pdpSelectedProtectionPlanId
      });
      if (errors) {
        setAddToCartError(errors?.[0]?.message || "Unable to add to cart. Please try again.");
        return;
      }
      const insightsMatch = lastInsightsClick?.product_id === basicDetails.id || lastInsightsClick?.objectID === basicDetails.id;
      if (insightsMatch) {
        handleInsightsAddToCart({
          hit: lastInsightsClick,
          productData: basicDetails
        });
      }
      onAddToCartClicked?.();
      addToCartEvent(cart, cartToken, mode);
    };
    $[3] = addModularToCart;
    $[4] = addToCart;
    $[5] = addToCartEvent;
    $[6] = basicDetails;
    $[7] = lastInsightsClick;
    $[8] = mode;
    $[9] = onAddToCartClicked;
    $[10] = optionData.selectedOptions;
    $[11] = pdpIsModularBYOProduct;
    $[12] = pdpSelectedCustomizerTab;
    $[13] = pdpSelectedProtectionPlanId;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const onAddToCart = t14;
  let t15;
  let t16;
  if ($[15] !== isZipCodeFromUserServiceable) {
    t15 = () => {
      if (isZipCodeFromUserServiceable) {
        setAddToCartError(null);
      }
    };
    t16 = [isZipCodeFromUserServiceable];
    $[15] = isZipCodeFromUserServiceable;
    $[16] = t15;
    $[17] = t16;
  } else {
    t15 = $[16];
    t16 = $[17];
  }
  useEffect(t15, t16);
  let t17;
  bb0: {
    if (availabilityLoading || optionsLoading || modularDetailsLoading) {
      t17 = false;
      break bb0;
    }
    if (isEFGInternal || isEmpty(optionData?.options) || optionData?.pdpHasUserSelectedOptions || !optionData?.upholsteryOptionId || pdpSelectedCustomizerTab !== PDP_CUSTOMIZE_TAB_ID || optionData?.options.find(optValue => optValue.id === optionData?.upholsteryOptionId)?.values?.length === 1) {
      t17 = false;
      break bb0;
    }
    t17 = true;
  }
  const allowUserToCustomize = t17;
  let t18;
  bb1: {
    if (!!optionData.stock?.stockOptionsCombined?.length && isRTSTab) {
      const updatedDisabledState = getCombinedOptionSKUs(optionData.selectedOptionsVariantSku, optionData.stock?.stockOptionsCombined);
      t18 = updatedDisabledState;
      break bb1;
    }
    t18 = [];
  }
  const validStockOptionSkus = t18;
  let t19;
  bb2: {
    if (availabilityLoading || optionsLoading) {
      t19 = false;
      break bb2;
    }
    if (validStockOptionSkus?.length && optionData?.selectedOptionsVariantSku) {
      if (!validStockOptionSkus.includes(optionData?.selectedOptionsVariantSku)) {
        t19 = true;
        break bb2;
      }
    }
    if (!optionData?.stock?.stockOptions?.length || isOutOfStock) {
      t19 = isOutOfStock;
      break bb2;
    }
    const {
      selectionValidity
    } = optionData.stock;
    let t20;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = [PDP_SELECTION_VALIDITY_STATES.INVALID, PDP_SELECTION_VALIDITY_STATES.INACTIVE];
      $[18] = t20;
    } else {
      t20 = $[18];
    }
    t19 = t20.includes(selectionValidity);
  }
  const isCartDisabled = t19;
  let t20;
  if ($[19] !== basicDetails?.id || $[20] !== basicDetails?.meta?.collectionSlug || $[21] !== modularDetailsData.isModularBundleProduct || $[22] !== modularDetailsData.preConfigProducts) {
    t20 = () => {
      if (!modularDetailsData?.isModularBundleProduct || !modularDetailsData?.preConfigProducts?.length) {
        return;
      }
      const updatedProducts = modularDetailsData.preConfigProducts.filter(prod => !!prod && prod.id !== basicDetails?.id);
      let finalSlug = basicDetails?.meta?.collectionSlug ? basicDetails?.meta?.collectionSlug.replace("collections/", "") : "";
      finalSlug = finalSlug.length ? `${finalSlug.charAt(0).toUpperCase()}${finalSlug.slice(1)}` : "";
      updateBuildYourOwnDetails({
        name: finalSlug,
        urlKey: `/modular/${finalSlug.toLowerCase()}-modular/`,
        dimensions: `Choose from ${updatedProducts.length} pieces to make any configuration.`
      });
    };
    $[19] = basicDetails?.id;
    $[20] = basicDetails?.meta?.collectionSlug;
    $[21] = modularDetailsData.isModularBundleProduct;
    $[22] = modularDetailsData.preConfigProducts;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  const t21 = basicDetails?.id;
  const t22 = basicDetails?.meta?.collectionSlug;
  const t23 = modularDetailsData?.isModularBundleProduct;
  let t24;
  if ($[24] !== modularDetailsData.preConfigProducts || $[25] !== t21 || $[26] !== t22 || $[27] !== t23) {
    t24 = [t21, t22, t23, modularDetailsData.preConfigProducts];
    $[24] = modularDetailsData.preConfigProducts;
    $[25] = t21;
    $[26] = t22;
    $[27] = t23;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  useEffect(t20, t24);
  const t25 = optionData?.selectedOptionsVariantSku;
  let t26;
  if ($[29] !== basicDetails || $[30] !== t25) {
    t26 = {
      basicDetails,
      selectedOptionsVariantSku: t25
    };
    $[29] = basicDetails;
    $[30] = t25;
    $[31] = t26;
  } else {
    t26 = $[31];
  }
  useJbEventFBAddToCart(t26);
  const loading = basicDetailsLoading || optionsLoading || pageLoading || modularDetailsLoading;
  const t27 = pdpIsModularBYOProduct ? modularAddingToCart : addingToCart;
  const t28 = loading || isCartDisabled || pdpIsModularBYOProduct && !modularTotalPrice || isMarkedOOSOrDiscontinued && (isOutOfStock || isDiscontinued);
  const t29 = basicDetails?.meta?.collectionSlug;
  const t30 = modularDetailsData?.isModularBundleProduct;
  const t31 = !loading ? onAddToCart : undefined;
  const t32 = basicDetails?.meta?.price?.final_price;
  const t33 = isClearance && !clearanceStockPerSKU?.flashSale && !isDecideLaterTab;
  const t34 = basicDetails?.custom_properties?.campaign;
  let t35;
  if ($[32] !== addToCartError || $[33] !== allowUserToCustomize || $[34] !== buildYourOwnDetails || $[35] !== isDiscontinued || $[36] !== isOutOfStock || $[37] !== loading || $[38] !== mode || $[39] !== selectedMaterial || $[40] !== stickyDesktopButtonOnly || $[41] !== t27 || $[42] !== t28 || $[43] !== t29 || $[44] !== t30 || $[45] !== t31 || $[46] !== t32 || $[47] !== t33 || $[48] !== t34) {
    t35 = <PDPAddToBagSectionUI addToCartError={addToCartError} addingToCart={t27} allowUserToCustomize={allowUserToCustomize} buildYourOwnDetails={buildYourOwnDetails} cartDisabled={t28} collectionSlug={t29} isDiscontinued={isDiscontinued} isModularBundleProduct={t30} isOutOfStock={isOutOfStock} loading={loading} mode={mode} onAddToCart={t31} price={t32} showClearanceAlert={t33} stickyDesktopButtonOnly={stickyDesktopButtonOnly} campaign={t34} selectedMaterial={selectedMaterial} />;
    $[32] = addToCartError;
    $[33] = allowUserToCustomize;
    $[34] = buildYourOwnDetails;
    $[35] = isDiscontinued;
    $[36] = isOutOfStock;
    $[37] = loading;
    $[38] = mode;
    $[39] = selectedMaterial;
    $[40] = stickyDesktopButtonOnly;
    $[41] = t27;
    $[42] = t28;
    $[43] = t29;
    $[44] = t30;
    $[45] = t31;
    $[46] = t32;
    $[47] = t33;
    $[48] = t34;
    $[49] = t35;
  } else {
    t35 = $[49];
  }
  return t35;
};
PDPAddToBagSectionInner.propTypes = {
  mode: PropTypes.oneOf(['quickview', 'pdp']),
  onAddToCartClicked: PropTypes.func,
  pageLoading: PropTypes.bool,
  productId: PropTypes.number,
  slug: PropTypes.string,
  stickyDesktopButtonOnly: PropTypes.bool,
  isEditOrder: PropTypes.bool
};
const PDPAddToBagSection = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPAddToBagSectionPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPAddToBagSectionInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPAddToBagSection;